export default {"src":"/_next/static/media/Pediatric and Adolescent Nutrition.2b5c42ae.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};